
import React from "react";
import { Printer } from "@/hooks/use-printer-search";
import { Contributor } from "@/hooks/use-contributors";
import { PartFilter } from "@/data/parts";
import PrinterSelector from "./PrinterSelector";
import ContributorInput from "./ContributorInput";
import TitleRow from "./TitleRow";
import CoverImageRow from "./CoverImageRow";
import DescriptionSection from "./DescriptionSection";
import RequirementsSection from "./RequirementsSection";
import TagsSection from "./TagsSection";

interface BasicInformationSectionProps {
  title: string;
  coverImage: string;
  shortDescription: string;
  tags: string[];
  selectedPrinters: Printer[];
  contributors: Contributor[];
  requirements: PartFilter[];
  onTitleChange: (title: string) => void;
  onCoverImageChange: (coverImage: string) => void;
  onDescriptionChange: (description: string) => void;
  onTagsChange: (tags: string[]) => void;
  onPrintersChange: (printers: Printer[]) => void;
  onContributorsChange: (contributors: Contributor[]) => void;
  onRequirementsChange: (requirements: PartFilter[]) => void;
}

const BasicInformationSection: React.FC<BasicInformationSectionProps> = ({
  title,
  coverImage,
  shortDescription,
  tags,
  selectedPrinters,
  contributors,
  requirements,
  onTitleChange,
  onCoverImageChange,
  onDescriptionChange,
  onTagsChange,
  onPrintersChange,
  onContributorsChange,
  onRequirementsChange
}) => {
  // Check if any selected printer is Creality K1 or K2 series
  const hasCrealityK1K2 = selectedPrinters.some(printer => 
    printer.name.toLowerCase().includes('k1') || 
    printer.name.toLowerCase().includes('k2')
  );

  return (
    <div className="space-y-6">
      <TitleRow
        title={title}
        onTitleChange={onTitleChange}
      />

      <CoverImageRow
        coverImage={coverImage}
        onCoverImageChange={onCoverImageChange}
      />

      <DescriptionSection
        shortDescription={shortDescription}
        onDescriptionChange={onDescriptionChange}
      />

      <div className="space-y-4">
        <PrinterSelector
          selectedPrinters={selectedPrinters}
          onChange={onPrintersChange}
          integrated={true}
        />
      </div>

      <RequirementsSection
        requirements={requirements}
        onRequirementsChange={onRequirementsChange}
        hasCrealityK1K2={hasCrealityK1K2}
      />

      <TagsSection
        tags={tags}
        onTagsChange={onTagsChange}
      />

      <ContributorInput
        contributors={contributors}
        onContributorsChange={onContributorsChange}
      />
    </div>
  );
};

export default BasicInformationSection;
